export default {
    dfCheck: "/static/images/dfc-logo-dark.png",
    loginBackground: "/static/images/login-background.jpg",
    checkventory: "/static/images/cv-logo-dark.png",
    lotCountDark: "/static/images/lotcount-dark-logo.png",
    logoLight: "/static/images/cv-logo-light.png",
    uverifi: "/static/images/uVerifi-logo-dark.png"
};
